import CommunicationPane from './CommunicationPane';

export default CommunicationPane;
